import IconSelect from './IconSelect';

export default IconSelect;
